export interface IViewTicketTabs {
    summary: string;
    activity: string;
}
export default class Route {

    public static get DashboardRoute(): string {
        return '/app/dashboard';
    }

    public static get Tickets(): string {
        return '/incidents';
    }

    public static get Open(): string {
        return '/incidents/open';
    }

    public static get sortByP1(): string {
        return 'open?sort=priority:p1';
    }

    public static get sortByP2(): string {
        return 'open?sort=priority:p2';
    }

    public static get sortByStatus(): string {
        return 'open?sort=status:action';
    }

    public static get Closed(): string {
        return '/incidents/closed';
    }

    public static get NewTicket(): string {
        return 'new-incident';
    }

    public static get PageNotFoundRoute(): string {
        return '/app/errors/not-found';
    }

    public static get ViewIncidentsRoute(): string {
        return ':sniNumber/:tab';
    }

    public static get OpenTicketRoute(): string {
        return '/app/incidents/open';
    }

    public static get IncidentsRoute(): string {
        return '/app/incidents';
    }
    public static get NewIncidentSubmissionRoute(): string {
        return 'new-incident/submission';
    }

    public static get ClosedTicketRoute(): string {
        return '/app/incidents/closed';
    }

    public static get ViewTicketTabs(): IViewTicketTabs {
        return {
            summary: 'summary',
            activity: 'activity'
        };
    }

    public static get ViewIncidentsClosedRoute(): string {
        return 'view/closed/:sniNumber/:tab';
    }

    public static get ViewIncidentsOpenRoute(): string {
        return 'view/open/:sniNumber/:tab';
    }

    public static get MajorIncidentRoute(): string {
        return 'major/:sniNumber/:tab';
    }

    public static get CustomerSupportEnquiryRoute(): string {
        return '/app/customer-support/new-enquiry';
    }

    public static get SupportErrorReportRoute(): string {
        return '/app/support/error-report';
    }

    public static get TrackingBaseRoute(): string {
        return 'app/tracking/';
    }

    public static get TrackingRoute(): string {
        return '/app/tracking/incidents';
    }

    public static get TrackGuestIncidentsLinkRoute(): string {
        return '/app/incidents/guest-incidents';
    }

    public static get CreateGuestIncidentRoute(): string {
        return 'create-guest-incident';
    }

    public static get TrackGuestIncidentsRoute(): string {
        return 'guest-incidents';
    }

    public static get ViewGuestIncidentRoute(): string {
        return 'guest/:sniNumber';
    }

    public static ViewIncidents(sniNumber: string, tab: string): string {
        return this.ViewIncidentsRoute
            .replace(':sniNumber', sniNumber)
            .replace(':tab', tab);
    }

    public static MajorIncident(sniNumber: string, tab: string): string {
        return this.MajorIncidentRoute
            .replace(':sniNumber', sniNumber)
            .replace(':tab', tab);
    }

    public static ViewIncidentsClosed(sniNumber: string, tab: string): string {
        return this.ViewIncidentsClosedRoute
            .replace(':sniNumber', sniNumber)
            .replace(':tab', tab);
    }

    public static ViewIncidentsOpen(sniNumber: string, tab: string): string {
        return this.ViewIncidentsOpenRoute
            .replace(':sniNumber', sniNumber)
            .replace(':tab', tab);
    }

    public static ViewGuestIncident(sniNumber: string): string {
        return this.ViewGuestIncidentRoute.replace(':sniNumber', sniNumber);
    }
}
